<template>
  <div class="flex flex-col flex-grow">
    <div
      class="flex-grow h-[300px] overflow-auto border border-stone-300 dark:border-stone-600 rounded-lg bg-stone-50 dark:bg-stone-900">
      <template v-for="(entry, i) in entries">
        <advancedSlice :ref="'entry' + i" :entry="entry" :i="i" />
      </template>
    </div>
    <button class="btn btn-primary w-full mt-2" @click="addEntry()" :disabled="wheelIsBusy">
      {{ t('advancededitor.Add entry') }}
    </button>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useI18n } from 'vue-i18n';
import { useWheelStore } from '@/stores/useWheelStore';
import advancedSlice from './advancedSlice.vue';
import * as Util from '@utils/Util.js';

const { t } = useI18n();
const wheelStore = useWheelStore();

const wheelConfig = computed(() => wheelStore.wheelConfig);
const entries = computed(() => wheelConfig.value?.entries || []);
const wheelIsBusy = computed(() => wheelStore.wheelIsBusy);

function addEntry() {
  Util.trackEvent('Wheel', 'AddAdvancedEntry');
  wheelStore.appendEntry({ text: '', color: '#CCCCCC', weight: 1, enabled: true });
  focusLastEntry();
}

function focusLastEntry() {
  const inst = getCurrentInstance();
  if (!inst) return;
  const lastIndex = entries.value.length - 1;
  const refKey = 'entry' + lastIndex;
  // String refs produce arrays when used in v-for
  const target = inst.proxy?.$refs?.[refKey]?.[0];
  if (target && typeof target.focus === 'function') {
    setTimeout(() => target.focus(), 100);
  }
}
</script>
